import { AdminShell } from "@project/admin/components/admin-shell";
import { ApiResourceTable } from "@project/admin/components/api-resource-table";
import type { Field } from "@project/admin/components/resource-table";
import { relationshipService } from "@project/services/admin/relationship.service";
import {
  type Relationship,
  RELATIONSHIP_NAME_OPTIONS,
  RELATIONSHIP_NAME_TO_CODE,
} from "@project/types/relationship";

const genderOptions = ["Male", "Female", "Both"].map(v => ({
  value: v,
  label: v,
}));

const fields: Field[] = [
  {
    name: "relationship_name",
    label: "Relationship Name",
    type: "select",
    required: true,
    showInTable: true,
    placeholder: "Select relationship...",
    options: RELATIONSHIP_NAME_OPTIONS,
    linkedField: {
      target: "relationship_code",
      valueMap: RELATIONSHIP_NAME_TO_CODE,
    },
  },
  {
    name: "relationship_code",
    label: "Code",
    required: true,
    showInTable: true,
    readOnly: true,
    help: "Auto-filled when you select a relationship name",
  },
  {
    name: "description",
    label: "Description",
    type: "textarea",
    showInTable: true,
    placeholder: "Biological Father",
  },
  {
    name: "gender_applicable",
    label: "Gender Applicable",
    type: "select",
    required: true,
    showInTable: true,
    options: genderOptions,
  },
  { name: "is_active", label: "Active", type: "boolean", showInTable: true },
];

export default function Page() {
  return (
    <AdminShell
      title="Relationships"
      subtitle="Manage family relationship types for resident records"
    >
      <ApiResourceTable<Relationship>
        title="Relationship"
        labelField="relationship_name"
        fields={fields}
        searchFields={["relationship_name", "relationship_code"]}
        defaultValues={{ is_active: true, gender_applicable: "Male" }}
        list={query => relationshipService.listRelationshipsPage(query)}
        create={payload =>
          relationshipService.createRelationship({
            relationship_name: String(payload.relationship_name),
            relationship_code: String(payload.relationship_code),
            description: payload.description
              ? String(payload.description)
              : undefined,
            gender_applicable: String(payload.gender_applicable),
            is_active: Boolean(payload.is_active),
          })
        }
        update={(id, payload) =>
          relationshipService.updateRelationship(id, {
            relationship_name:
              payload.relationship_name !== undefined
                ? String(payload.relationship_name)
                : undefined,
            relationship_code:
              payload.relationship_code !== undefined
                ? String(payload.relationship_code)
                : undefined,
            description:
              payload.description !== undefined
                ? String(payload.description)
                : undefined,
            gender_applicable:
              payload.gender_applicable !== undefined
                ? String(payload.gender_applicable)
                : undefined,
            is_active:
              payload.is_active !== undefined
                ? Boolean(payload.is_active)
                : undefined,
          })
        }
        remove={id => relationshipService.deleteRelationship(id)}
      />
    </AdminShell>
  );
}
